module.exports = __webpack_public_path__ + "img/00010.30583139.webp";